/**
 * Member screens M05–M19 and share-out day, children of /app (route map: docs/PLAN.md, M15; server
 * notification links point at these paths). Each screen's code loads on its first visit, so the first
 * download stays small on mobile data.
 */
import type { RouteObject } from 'react-router'
import { lazyScreen } from './lazyScreen'

export const memberRoutes: RouteObject[] = [
  { path: 'home', element: lazyScreen(() => import('./screens/HomePage').then((m) => ({ default: m.HomePage }))) },
  { path: 'pay', element: lazyScreen(() => import('./screens/SavePage').then((m) => ({ default: m.SavePage }))) },
  {
    path: 'pay/:paymentId',
    element: lazyScreen(() => import('./screens/PaymentPage').then((m) => ({ default: m.PaymentPage }))),
  },
  {
    path: 'activity',
    element: lazyScreen(() => import('./screens/ActivityPage').then((m) => ({ default: m.ActivityPage }))),
  },
  {
    path: 'activity/queries/:queryId',
    element: lazyScreen(() => import('./screens/QueryPage').then((m) => ({ default: m.QueryPage }))),
  },
  {
    path: 'activity/:entryId',
    element: lazyScreen(() => import('./screens/ReceiptPage').then((m) => ({ default: m.ReceiptPage }))),
  },
  { path: 'pledge', element: lazyScreen(() => import('./screens/PledgePage').then((m) => ({ default: m.PledgePage }))) },
  { path: 'loans', element: lazyScreen(() => import('./screens/LoansPage').then((m) => ({ default: m.LoansPage }))) },
  {
    path: 'loans/apply',
    element: lazyScreen(() => import('./screens/ApplyPage').then((m) => ({ default: m.ApplyPage }))),
  },
  { path: 'loans/:loanId', element: lazyScreen(() => import('./screens/LoanPage').then((m) => ({ default: m.LoanPage }))) },
  {
    path: 'loans/:loanId/offer',
    element: lazyScreen(() => import('./screens/OfferPage').then((m) => ({ default: m.OfferPage }))),
  },
  {
    path: 'loans/:loanId/repay',
    element: lazyScreen(() => import('./screens/RepayPage').then((m) => ({ default: m.RepayPage }))),
  },
  {
    path: 'statement',
    element: lazyScreen(() => import('./screens/StatementPage').then((m) => ({ default: m.StatementPage }))),
  },
  {
    path: 'statement/group/:period',
    element: lazyScreen(() => import('./screens/GroupStatementPage').then((m) => ({ default: m.GroupStatementPage }))),
  },
  {
    path: 'guarantees',
    element: lazyScreen(() => import('./screens/GuaranteesPage').then((m) => ({ default: m.GuaranteesPage }))),
  },
  {
    path: 'guarantees/:requestId',
    element: lazyScreen(() => import('./screens/GuaranteePage').then((m) => ({ default: m.GuaranteePage }))),
  },
  {
    path: 'profile',
    element: lazyScreen(() => import('./screens/ProfilePage').then((m) => ({ default: m.ProfilePage }))),
  },
  {
    path: 'shareout/:runId/live',
    element: lazyScreen(() => import('./screens/ShareoutLivePage').then((m) => ({ default: m.ShareoutLivePage }))),
  },
]
